// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ha_2","type":"styles_type__1B5Um","choices":"styles_choices__n7SGZ"};